import featureFlagService from './index';

export default class FeatureFlagServiceFacade {
  get() {
    return (featureFlagService.get());
  }

  is(featureName) {
    return (featureFlagService.is(featureName));
  }

  subscribe(flagName, callback) {
    return featureFlagService.subscribe(flagName, callback);
  }

  static build() {
    return new FeatureFlagServiceFacade();
  }
}
